import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Course } from "@domain/lms/course/course";
import { Secondary } from "@ui/components/containers/textBlocks";
import { CourseThumbnail } from "@ui/components/course/courseThumbnail";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { desktop, gap, mobile } from "@ui/styles/utils";

interface FavoriteCoursesListProps extends React.HTMLAttributes<HTMLDivElement> {
	totalElements: number | undefined;
	courses: Course[];
	loading: boolean;
	moreLoading: boolean;
	fetchMore: () => Promise<void>;
}

export const FavoriteCoursesList: React.FC<FavoriteCoursesListProps> = ({
	totalElements = 0,
	courses,
	loading,
	moreLoading,
	fetchMore,
	...htmlProps
}) => {
	if (totalElements === 0) {
		return <Secondary>{I18n.t("profile.favorite.empty")}</Secondary>;
	}
	return (
		<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
			<Courses {...htmlProps}>
				{courses.map((course) => (
					<CourseThumbnail key={course.id} course={course} />
				))}
				{loading && <ClipLoader />}
			</Courses>
		</InfiniteScroll>
	);
};

const Courses = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
